import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as UserUpdateActions from '../actions/user-update.actions';
import {UsersService} from '../../../services/api/users/users.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {ManageUserPayload, UpdateUserResponse} from '../../../services/api/users/user.model';


@Injectable()
export class UserUpdateEffects {

  userUpdate$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserUpdateActions.userUpdate),
      concatMap((payload: { id: number, data: ManageUserPayload }) =>
        this.usersService.updateUser(payload.id, payload.data).pipe(
          map((data: UpdateUserResponse) => UserUpdateActions.userUpdateSuccess({data})),
          catchError((error: unknown) => of(UserUpdateActions.userUpdateFailure({error}))))
      )
    );
  });

  userUpdateSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserUpdateActions.userUpdateSuccess),
      tap(() => {
        this.snackBar.open('User successfully updated', 'Success', {duration: 3000});
        if (this.router.url.includes('/organizations/')) {
          this.router.navigate(['/organizations']);
        } else {
          this.router.navigate(['/organization']);
        }
      })
    );
  }, {dispatch: false});


  constructor(private actions$: Actions,
              private usersService: UsersService,
              private router: Router,
              private snackBar: MatSnackBar) {
  }

}
